export class BadRequestError<R = unknown> extends Error {
  constructor(public data?: R) {
    super();
  }
}
